import itemAccount from './itemAccount';
import account from './account';
import itemGroup from './itemGroup'
import measureUnit from './measureUnit'
import itemAccountType from './itemAccountType'
import itemType from './itemType'
import item from './item'
import permission from './permission'
import itemMeasureUnit from './itemMeasureUnit';
import warehouseItem from './warehouseItem';

export default {
    namespaced: true,
    modules: {
        account,
        itemGroup,
        measureUnit,
        itemAccountType,
        itemType,
        item,
        permission,
        itemAccount,
        itemMeasureUnit,
        warehouseItem
    }
}